var QRMath = function() {
  var EXP_TABLE = new Array(256)
  var LOG_TABLE = new Array(256)

  // initialize tables
  for (var i = 0; i < 8; i += 1) {
    EXP_TABLE[i] = 1 << i
  }
  for (var i = 8; i < 256; i += 1) {
    EXP_TABLE[i] = EXP_TABLE[i - 4]
      ^ EXP_TABLE[i - 5]
      ^ EXP_TABLE[i - 6]
      ^ EXP_TABLE[i - 8]
  }
  for (var i = 0; i < 255; i += 1) {
    LOG_TABLE[EXP_TABLE[i] ] = i
  }

  var _this = {}

  _this.glog = function(n) {

    if (n < 1) {
      throw new Error('glog(' + n + ')')
    }

    return LOG_TABLE[n]
  }

  _this.gexp = function(n) {

    while (n < 0) {
      n += 255
    }

    while (n >= 256) {
      n -= 255
    }

    return EXP_TABLE[n]
  }

  return _this
}()

module.exports = QRMath



//////////////////
// WEBPACK FOOTER
// ./~/qr-encode/lib/math.js
// module id = 495
// module chunks = 6